export const setRedirect = (dispatch, path) => {
  return dispatch({
    type: "SET_PATH",
    payload: path,
  })
}
